define('app/views/travel_search_types_view',['app/setup'],
  function(takhfifan, dealCard, dealCollection) {
  takhfifan.travelSearchTypesView = Backbone.View.extend({

    template: ( $('#travel-search-types-template').length > 0 ) ?
      _.template( $('#travel-search-types-template').html() ) : '',

    events: {
      "click .FAQ" : "toggleAccordion",
      "click .linksRow a" : "scrollToTop"
    },

    initialize: function () {
      var _this = this;
      
      this.availableTypes = this.$('.tkh-travel-search-types__selector');  
      this.postponeViewId = null;
      this.initViews();
      takhfifan.eventHub.on('travel:typeChanged', function (options) {
        this.changeSearchType(options.type);
      }, this);

      takhfifan.eventHub.on('travel:renderResults', function (options) {
        this.changeSearchType(options.type);
      }, this);

      this.$('.tkh-travel-search-types__selector:nth-child(1) a span').addClass('icon-backpack');
      this.$('.tkh-travel-search-types__selector:nth-child(2) a span').addClass('icon-bed');
      this.$('.tkh-travel-search-types__selector:nth-child(3) a span').addClass('icon-train-on-railroad');
      this.$('.tkh-travel-search-types__selector:nth-child(4) a span').addClass('icon-airplane');
    },

    initViews: function () {
      if(this.postponeViewId){
        this.changeSearchType(this.postponeViewId);
      }
    },

    changeSearchType: function (activeId) {
      if(this.availableTypes.length){
        if(!_.find(this.availableTypes,function(item){return item.id == activeId})){
          activeId = "default";
        }
        this.$('.tkh-travel-search-types__item[data-type="'+activeId+'"]').addClass('active');
        this.$('.tkh-travel-search-types__results[data-type="'+activeId+'"]').addClass('active');
        this.$('.tkh-travel-search-types__results[data-type="'+activeId+'"]').css('display', 'block');
        var $relatedResultView = this.$('.tkh-travel-search-types__results[data-type="'+activeId+'"]');
        //TODO: we should change this condition, it is not reliable
        //if($relatedResultView.children()[0].className.indexOf('--no-result') === -1){
        //  $relatedResultView.show();
        //}else{
          //this.$('.tkh-travel-search-types__results[data-type="default"]').show();
        //}
        this.postponeViewId = null;
      }else{
        this.postponeViewId = activeId;
      }
    },

    toggleAccordion: function () {
      this.$('.faqAccordion').toggle();
    },

    scrollToTop: function () {
      $('html,body').animate({scrollTop: 0}, 500);
    }
  })
});
